import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { HomePage } from './pages/HomePage';
import { ProductDIYKit } from './pages/ProductDIYKit';
import { ProductCompleteKit } from './pages/ProductCompleteKit';
import { AboutPage } from './pages/AboutPage';
import { WarrantyPage } from './pages/WarrantyPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/products/forcex-diy" element={<ProductDIYKit data-id="element-6" />} data-id="element-5" />
          <Route path="/products/forcex-complete" element={<ProductCompleteKit data-id="element-8" />} data-id="element-7" />
          <Route path="/about" element={<AboutPage data-id="element-10" />} data-id="element-9" />
          <Route path="/warranty" element={<WarrantyPage data-id="element-12" />} data-id="element-11" />
          <Route path="/contact" element={<ContactPage data-id="element-14" />} data-id="element-13" />
          {/* Fallback route */}
          <Route path="*" element={<HomePage data-id="element-16" />} data-id="element-15" />
        </Routes>
      </Layout>
    </Router>;
}